import Svg, { G, Path, Defs, ClipPath, type SvgProps } from 'react-native-svg'
import { randomUUID } from '@/src/common/utils/randomUUID'
import type { ColorValue } from 'react-native'
import { useState } from 'react'

export function UnfreezeIcon({
  slashBackgroundColor,
  ...props
}: SvgProps & {
  slashBackgroundColor?: ColorValue
}) {
  const [clipPathId] = useState(randomUUID)
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <G clipPath={`url(#${clipPathId})`} strokeLinecap="round" strokeLinejoin="round">
        <Path
          d="M2 12h20M12 2v20M20 16l-4-4 4-4M4 8l4 4-4 4M16 4l-4 4-4-4M8 20l4-4 4 4M2 3l20 20"
          stroke="#fff"
          strokeWidth={2}
        />
        <Path d="M3 1l20 20" stroke={slashBackgroundColor} strokeWidth={2.25} />
      </G>
      <Defs>
        <ClipPath id={clipPathId}>
          <Path fill="#fff" d="M0 0H24V24H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
